export const MAX_EMAIL_LENGTH = 50;
export const MAX_BIO_LENGTH = 300;
export const MAX_USERNAME_LENGTH = 16;
export const MAX_DESCRIPTION_LENGTH = 1000;
export const MAX_CAMPAIGN_NAME_LENGTH = 60;
export const MAX_CAMPAIGN_TAGLINE_LENGTH = 240;
